import sliderSVG from '@plone/volto/icons/slider.svg';
import {linkListSchema} from 'nsw-design-system-plone6/components/Blocks/LinkList/schema';
import {EmbedContentViewWrapper} from './EmbedContentViewWrapper';
import {LinkListBlock, LinkListWrapper} from './LinkListRepeaterBlockView';


export default function applyConfig(config) {
  config.settings["volto-repeater-block"].allowedBlocks = [
    ...(config.settings["volto-repeater-block"]?.allowedBlocks ?? []),
    "nsw_internal_link_list"
  ];
  config.settings["volto-repeater-block"].mappings = {
    ...(config.settings["volto-repeater-block"]?.mappings ?? {}),
    card: {
      facetSource: {
        title: "title",
        url: "url",
      },
    },
    nsw_internal_link_list: {
      facetSource: {
        title: "title",
        url: "url",
        url: "url",
      },
    },
  };

  config.blocks.blocksConfig['nsw_internal_link_list'] = {
    id: 'nsw_internal_link_list',
    title: 'Link list item',
    icon: sliderSVG,
    group: 'common',
    view: LinkListBlock,
    // edit: RepeaterBlockEdit,
    blockSchema: linkListSchema,
    RepeaterWrapper: LinkListWrapper,
    restricted: true,
    mostUsed: false,
    sidebarTab: 1,
  };

  // We want it disabled by default. Enable it in the relevant site, e.g. MHCS.
  config.blocks.blocksConfig['repeater-block'].restricted = true;

  config.registerComponent({
    name: 'EmbedContentViewWrapper',
    component: EmbedContentViewWrapper,
  });

  return config;
}
